import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-speed-gauge',
  templateUrl: './speed-gauge.component.html',
  styleUrls: ['./speed-gauge.component.css']
})
export class SpeedGaugeComponent implements OnInit {
  @Input() speed = 0;
  @Input() unit = 'KM';
  @ViewChild('speedNeedle') speedNeedle!: ElementRef<HTMLElement>;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.setSpeed(this.speed);
  }

  setSpeed(speed: number) {
    const minAngle = -63;
    const maxAngle = 163;
    const maxSpeed = 180;

    const angle = minAngle + (speed / maxSpeed) * (maxAngle - minAngle);
    this.speedNeedle.nativeElement.style.transform = `rotate(${angle}deg)`;
  }

}
